var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.754,
    height: 68.463,
    viewBox: "0 0 61.754 68.463",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_365",
    "data-name": "Grupo 365",
    transform: "translate(-63.163 -401.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_363",
    "data-name": "Grupo 363"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8171",
    "data-name": "Trazado 8171",
    d: "M94.04,436.76a17.612,17.612,0,1,1,17.611-17.612A17.631,17.631,0,0,1,94.04,436.76Zm0-33.165a15.553,15.553,0,1,0,15.553,15.553A15.571,15.571,0,0,0,94.04,403.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_364",
    "data-name": "Grupo 364"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8172",
    "data-name": "Trazado 8172",
    d: "M124.917,470h-2.059a28.819,28.819,0,1,0-57.637,0H63.163a30.877,30.877,0,1,1,61.754,0Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.3bb74d2a815d1a4c55e0d4c476ec7af1.svg";
export { ForwardRef as ReactComponent };